@if (show()) {
  <div class="toolbar" @toolbarAnimation>
    <ng-content></ng-content>
  </div>

}
